import { useTranslations } from 'next-intl'
import Link from 'next/link'

type Props = {
  className: string
}

const Process = () => {
  const  t  = useTranslations()
  return [
    {
      id: t('analysis.id'),
      title: t('analysis.title'),
      content: t('analysis.content'),
    },
    {
      id: t('execution.id'),
      title: t('execution.title'),
      content: t('execution.content'),
    },
    {
      id: t('testing.id'),
      title: t('testing.title'),
      content: t('testing.content'),
    },
    {
      id: t('deployment.id'),
      title: t('deployment.title'),
      content: t('deployment.content'),
    },
  ]
}
const WorkProcess = ({ className }: Props) => {
  const  t  = useTranslations()

  return (
    <div
      className={`${className} flex flex-col gap-16 lg:grid lg:grid-cols-12`}
    >
      <div className='rounded-lg bg-secondary bg-linear-to-b from-primary from-50% to-secondary px-5 py-20 text-white lg:col-span-4 lg:px-10 lg:py-40'>
        <p className='mb-4 uppercase'>
          {t('homePage.workingProcess')}
        </p>
        <div className='flex flex-col gap-10'>
          <h3 className='text-2xl font-bold leading-loose xl:text-4xl'>
            {t('homePage.ourWorkingProcess ')}
          </h3>
          <Link
            href='/contact-us'
            className='w-fit rounded-lg bg-white to-100% px-9 py-4 font-semibold text-secondary transition-all duration-300 hover:bg-linear-to-r hover:from-primary hover:from-50% hover:to-secondary hover:text-white'
          >
            {t('homePage.learnMore')}
          </Link>
        </div>
      </div>
      <div className='lg:col-span-8'>
        <div className='grid gap-12 lg:grid-cols-2'>
          {Process().map(p => (
            <div className='flex flex-col' key={p.id}>
              <p className='mb-2 text-5xl font-bold text-orange'>{p.id}</p>
              <p className='mb-3 text-4xl font-bold'>{p.title}</p>
              <p className='leading-7'>{p.content}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default WorkProcess
